import React, { useRef, useState } from 'react'
import { Button, ConfigProvider, Modal } from 'antd'
import type { DraggableData, DraggableEvent } from 'react-draggable'
import Draggable from 'react-draggable'
import idataCodingStylesDark from '../../../pages/common/global-styles/idatacoding-dark.module.less'
import idataCodingStyles from '../../../pages/common/global-styles/idatacoding.module.less'
import zhCN from 'antd/es/locale/zh_CN'
export interface Props {
  tooltipopen: boolean
  setTooltipopen: any
  mode: string
  onOk: () => void
  content: JSX.Element
  okText?: string
}

const TooltipModal: React.FC<Props> = (props) => {
  const { tooltipopen, setTooltipopen, mode, onOk, content, okText } = props
  const [disabled, setDisabled] = useState(false)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const draggleRef = useRef<HTMLDivElement>(null)

  const showModal = () => {
    setTooltipopen(true)
  }

  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e)
    setTooltipopen(false)
  }

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }

  return (
    <ConfigProvider locale={zhCN}>
      <Modal
        className={
          mode === 'user'
            ? idataCodingStyles.modalStyle
            : mode === 'oam'
            ? idataCodingStyles.modalStyle
            : {}
        }
        closable={false}
        centered={true}
        title={
          <div
            style={{
              width: '100%',
              cursor: 'move',
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            提示
          </div>
        }
        visible={tooltipopen}
        okText={okText}
        onOk={onOk}
        onCancel={handleCancel}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        {content}
      </Modal>
    </ConfigProvider>
  )
}

export default TooltipModal
